<template>
  <div class="nkn-youtube">
    <div class="common-sub-title">{{$t("news.video.title")}}</div>
    <div v-if="lang === 'zh'" class="youtube-content">
      <video-player class="nkn-news-video" :options="video1Options" :playsinline="true"></video-player>
      <video-player class="nkn-news-video" :options="video2Options" :playsinline="true"></video-player>
      <video-player class="nkn-news-video" :options="video3Options" :playsinline="true"></video-player>
      <video-player class="nkn-news-video" :options="video4Options" :playsinline="true"></video-player>
    </div>
    <div v-else class="youtube-content">
      <video-player class="nkn-news-video" :options="introOptions" :playsinline="true"></video-player>
      <video-player class="nkn-news-video" :options="webOptions" :playsinline="true"></video-player>
      <video-player class="nkn-news-video" :options="sdkOptions" :playsinline="true"></video-player>

      <div class="more-link"><a href="https://www.youtube.com/c/NKNORG" target="_blank">View
        more</a></div>
      <!-- <swiper :options="swiperOption">
        <swiper-slide>
          <video-player class="nkn-news-video" :options="introOptions" :playsinline="true"></video-player>
        </swiper-slide>
        <swiper-slide>
          <video-player class="nkn-news-video" :options="webOptions" :playsinline="true"></video-player>
        </swiper-slide>
        <swiper-slide>
          <video-player class="nkn-news-video" :options="sdkOptions" :playsinline="true"></video-player>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper> -->
    </div>
  </div>
</template>

<script>
  import 'swiper/dist/css/swiper.css'
  import 'video.js/dist/video-js.css'
  import {
    videoPlayer
  } from 'vue-video-player'
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import {
    mapGetters,mapState
  } from 'vuex'
  import videoMix from '@/assets/js/nknVideoMix.js'

  export default {
    components: {
      swiper,
      swiperSlide,
      videoPlayer
    },
    computed: {
      ...mapState({
        lang: state => state.lang.lang
      })
    },
    mixins: [videoMix],
    data: function () {
      return {
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 15,
          slidesPerGroup: 3,
          loop: true,
          loopFillGroupWithBlank: true
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev'
          // }
        },
        introOptions: {
          height: '205',
          width: '345',
          autoplay: false,
          muted: false,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: this.$url.VIDEOLINKEN.nknIntro
          }],
          poster: '/static/img/news/video/Yilun.png'
        },
        sdkOptions: {
          height: '205',
          width: '345',
          autoplay: false,
          muted: false,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: this.$url.VIDEOLINKEN.nknSDK
          }],
          poster: '/static/img/news/video/SDK.png'
        },
        webOptions: {
          height: '205',
          width: '345',
          autoplay: false,
          muted: false,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: this.$url.VIDEOLINKEN.web3
          }],
          poster: '/static/img/news/video/Web3.0.png'
        },
        video1Options: {
          height: '205',
          width: '345',
          autoplay: false,
          muted: false,
          language: 'zh',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: '/static/video/mining_zh.mp4'
          }],
          poster: '/static/img/miner/NKN-60s-Chinese.png'
        },
        video2Options: {
          height: '205',
          width: '345',
          autoplay: false,
          muted: false,
          language: 'zh',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: '/static/video/nkn-intro_zh.mp4'
          }],
          poster: '/static/img/developer/video/NKN-tech-intro-Yilun_Chinese.png'
        },
        video3Options: {
          height: '205',
          width: '345',
          autoplay: false,
          muted: false,
          language: 'zh',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: 'https://media.nkn.org/videos/AMA%E4%B8%AD%E6%96%87%E4%BF%AE%E6%94%B9.mp4'
          }],
          poster: '/static/img/news/video/nkn-quest-7.png'
        },
        video4Options: {
          height: '205',
          width: '345',
          autoplay: false,
          muted: false,
          language: 'zh',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: 'https://media.nkn.org/videos/%E4%B8%AD%E6%96%87AMA6%E6%9C%88.mp4'
          }],
          poster: '/static/img/news/video/nkn-quest-6.png'
        }
      }
    },
    watch: {
      lang: function () {
        this.videoSet(this.introOptions, 'nknIntro')
        this.videoSet(this.sdkOptions, 'nknSDK')
        this.videoSet(this.webOptions, 'web3')
        this.videoSet(this.video1Options, 'video1Options')
        this.videoSet(this.video2Options, 'video2Options')
        this.videoSet(this.video3Options, 'video3Options')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .nkn-youtube {
    margin-top: 5rem;

    .video-outer {
      padding: 0;
    }

    .more-link {
      margin-right: 16px;
    }

    .more-link a {
      display: inline-block;
      font-size: 14px;
      color: #1791f2;
      width: 134px;
      height: 50px;
      line-height: 50px;
      float: right;
      margin-top: 20px;
      text-align: center;
      border: 1px solid #1791f2;
      border-radius: 4px;
      transition: all 0.2s;
      text-decoration: none !important;
    }

    .more-link:hover a {
      color: #ffffff;
      background-color: #1791f2;
      text-decoration: none !important;
    }

    .common-sub-title {
      padding-left: 20px;
    }

    .youtube-content {
      display: flex; justify-content: space-between; flex-wrap: wrap;
      margin-top: 2rem;
      padding-left: 20px;padding-right: 20px;
      @media screen and (max-width:1080px){
        flex-direction: column;
        align-items: center;
      }
      @media screen and (max-width:768px){
        flex-direction: column;
        align-items: center;
      }
      .video-review {
        width: 17rem;
        height: 20rem;
        box-shadow: inset 0 0 .2rem .05rem #d6dbee;
      }
    }

    .nkn-news-video {
      margin-bottom: 20px;
    }

    .swiper-button-prev {
      width: 0;
      height: 0;
      background: transparent;
      border: 1rem solid transparent;
      border-right-color: #253a7e;
    }

    .swiper-button-next {
      width: 0;
      height: 0;
      background: transparent;
      border: 1rem solid transparent;
      border-left-color: #253a7e;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news/nknYoutube.vue